import React from "react"; // Next.js 최신 JSX transform에선 없어도 됩니다.

export function linkify(text: string): Array<string | JSX.Element> {
  const urlRegex = /(\bhttps?:\/\/[^\s<]+)/gi;

  return text.split(urlRegex).map((part, i) => {
    if (urlRegex.test(part)) {
      return (
        <a key={part} href={part} target="_blank" rel="noopener noreferrer">
          {part}
        </a>
      );
    }
    return part;
  });
}
